// @flow
import { getCreator, postCreator } from '../../../http';
import environment from '../../../environment';

export const endpoints = Object.freeze({
  GET_RECEPTION_ORDERS: `${environment.apiUrl}/courier/order/list`,
  RECEIVE_ORDER_ITEM: `${environment.apiUrl}/courier/:orderItemId/receive`,
});

export const getReceptionOrdersApi = getCreator(fetch, endpoints.GET_RECEPTION_ORDERS);
export const receiveOrderItemApi = postCreator(fetch, endpoints.RECEIVE_ORDER_ITEM);



// WEBPACK FOOTER //
// ./src/modules/courier/recepetion/api.js